module.exports = __webpack_public_path__ + "static/media/alert.4989c744.svg";